import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useApp } from "../../AppContext";
import { PropTypes } from "prop-types";

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState();
  const { t } = useTranslation();
  const { balance, refetchBalance, config } = useApp();
  const location = useLocation();
  const selectedLanguage = localStorage.getItem("i18nextLng");
  const baseDomain = window.location.hostname.replace(/^account\./, "");
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      return (
        <li className="nav-item" key={key}>
          {prop.ignore ? null : (
            <Link
              to={prop.path}
              onClick={closeCollapse}
              className={`nav-link
              ${
                window.location.pathname.indexOf(prop.path) !== -1
                  ? " text-simbalotto-orange active"
                  : ""
              }
              `}
            >
              <i className={prop.icon} />
              {t(prop.name)}
            </Link>
          )}
        </li>
      );
    });
  };

  const { routes, logo } = props;

  async function logout() {
    fetch("/cookies/clear-logout", {
      method: "GET",
    }).then((response) => {
      if (response.status === 200) {
        window.location.href = `https://${baseDomain}${
          selectedLanguage === "en" ? "/logout" : `/${selectedLanguage}/logout`
        }`;
      }
    });
  }

  useEffect(() => {
    refetchBalance();
  }, [location, refetchBalance]);

  return (
    <nav
      className="navbar-vertical fixed-left navbar-light bg-white opacity-9 navbar navbar-expand-md"
      id="sidenav-main"
    >
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <i className="fa-solid fa-bars text-dark"></i>
        </button>

        {logo ? (
          <div className="pt-0 navbar-brand">
            {logo.innerLink ? (
              <Link to={logo.innerLink}>
                <img
                  alt={config?.app_name || logo.imgAlt}
                  src={config?.app_logo}
                  className="navbar-brand-img"
                />
              </Link>
            ) : (
              <a href={logo.outterLink}>
                <img
                  alt={logo.imgAlt}
                  src={logo.imgSrc}
                  className="navbar-brand-img"
                />
              </a>
            )}
          </div>
        ) : null}

        <ul className="align-items-center d-md-none nav">
          <div className="dropdown">
            <div
              role="button"
              id="userDropDown"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="avatar avatar-sm rounded-circle bg-simbalotto-orange text-simbalotto-green">
                <i className="fas fa-user" />
              </span>
            </div>

            <ul
              className="dropdown-menu dropdown-menu-right"
              aria-labelledby="userDropDown"
            >
              <li>
                <button className="dropdown-item" role="menuitem" type="button">
                  <i className="fas fa-wallet" />
                  <span>
                    {balance.toLocaleString("de-DE", {
                      style: "currency",
                      currency: "EUR",
                      minimumFractionDigits: 2,
                    })}
                  </span>
                </button>
              </li>
              <li>
                <Link className="dropdown-item" to="/my-profile">
                  <i className="fas fa-user" />
                  <span>{t("menu.my-profile")}</span>
                </Link>
              </li>
              <li>
                <button className="dropdown-item" onClick={() => logout()}>
                  <i className="fas fa-person-running" />
                  <span>{t("menu.logout")}</span>
                </button>
              </li>
            </ul>
          </div>
        </ul>

        <div
          className={`bg-white opacity-9 collapse navbar-collapse ${
            collapseOpen ? "show" : ""
          }`}
        >
          <div className="navbar-collapse-header d-md-none">
            <div className="row">
              {logo ? (
                <div className="col-6 collapse-brand">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </div>
              ) : null}
              <div className="collapse-close col-6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </div>
            </div>
          </div>
          <nav className="navbar-nav">
            <li className="nav-item">
              <a
                href={`https://${baseDomain}${
                  selectedLanguage === "en" ? "" : `/${selectedLanguage}`
                }/`}
                className="nav-link"
              >
                <i className="fas fa-baby-carriage" />
                {t("menu.play")}
              </a>
            </li>
            {createLinks(routes)}
            <li className="nav-item">
              <button className="btn nav-link" onClick={() => logout()}>
                <i className="fas fa-person-running" />
                {t("menu.logout")}
              </button>
            </li>
          </nav>
        </div>
      </div>
    </nav>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
